<template>
	<div class="desktop-menu menu-side-compact-w menu-activated-on-hover color-scheme-dark" >
		<div class="logo-w" v-sticky="{ zIndex: 5, stickyTop: 0 }">
			<a class="logo" href="index.html"><img src="static/assets/img/logo.png"></a>
		</div>
		<dock v-sticky="{ zIndex: 10, stickyTop: 60 }" />
	</div>
</template>

<script>
    import Dock from './dock'
    import ProfilePic from '@/components/user/ProfilePic'
    import VueSticky from 'vue-sticky'

    export default {
        components: { Dock, ProfilePic },
        directives: {
            'sticky': VueSticky,
        },
        name: 'navigation',
        data () {
            return {
                blurred: true
            }
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/Navigation.vue